/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.IPage<defs.basics.LabelInfoResponseDto>>;
export function request(
  params: API.basics.labelInfo.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/core/labelInfo/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
